module.exports = __webpack_public_path__ + "img/image 42.f3fc418f.svg";